import React from 'react';

const MedicalMarkers = () => (
	<g id="ic-medical" transform="translate(1535.000000, 931.000000)">
		<g transform="translate(4.000000, 4.000000)">
			<rect fill="#FFC6CE" x="0" y="0" width="24" height="24" rx="12"/>
			<rect fill="#FF103C" x="3" y="3" width="18" height="18" rx="9"/>
			<path
				d="M13.136486,5.62101824 L13.136,10.4960182 L18.375,10.4960182 L18.375,12.7460182 L13.136,12.7460182 L13.136486,18.3710182 L10.886486,18.3710182 L10.886,12.7460182 L5.625,12.7460182 L5.625,10.4960182 L10.886,10.4960182 L10.886486,5.62101824 L13.136486,5.62101824 Z"
				fill="#FFFFFF"/>
		</g>
	</g>
);

export default MedicalMarkers;
